import { setAlertWithTitle, setSpinnerLoading } from "../utility/Redux/modal";
import FirstIcodeItem from "./icodeEnterValue";
import uniqeid from "uniqid";
import moment from "moment";

export const emptyRowDetails = {
  id: uniqeid(),
  DEBIT_NOTE_NO: "",
  DATE: moment().format("YYYY-MM-DD"),
  ACCOUNT_NO: "",
  NAME: "",
  INVNO: "",
  PUR_BILL_NO: "",
  TOTAL: 0,
  GTOTAL: 0,
  REMARKS: "",
  ICODE: "",
  ITEMNAME: "",
  QNTY: "",
  RATE: 0,
  AMOUNT: 0,
  HSN_CODE: "",
  TAX1_RATE: 0,
  TAX1_AMOUNT: 0,
  TAX2_RATE: 0,
  TAX2_AMOUNT: 0,
  PACKING: "",
  UNIT: "",
};
export function enterRowWithItemDetails(
  itemDetail,
  rows,
  id,
  dispatch,
  setRows,
  setAlertTwoButtonModal,
  partyDetails
) {
  if (itemDetail) {
    const isSameICODEExists = rows.filter(
      (row) => row.ICODE === itemDetail.ICODE
    );
    const isSameIdExist = rows.filter((row) => row.id === id);
    if (!isSameICODEExists[0]) {
      if (isSameIdExist) {
        setRows((old) => {
          const list = old.map((item) => {
            if (item.id === id) {
              const i = FirstIcodeItem(id, partyDetails, itemDetail);

              return i;
            } else {
              return item;
            }
          });
          const isEmptyRow = list.filter((r) => r.ITEMNAME === "");
          if (isEmptyRow[0]) {
            return [...list];
          } else {
            return [
              ...list,
              {
                ...emptyRowDetails,
                id: uniqeid(),
              },
            ];
          }
        });
      } else {
        setRows((old) => {
          const i = FirstIcodeItem(uniqeid(), partyDetails, itemDetail);
          return [
            ...old,
            {
              ...i,
            },
            {
              ...emptyRowDetails,
              id: uniqeid(),
            },
          ];
        });
      }
      dispatch(setSpinnerLoading(false));
    } else {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "Item Already Exists",
        })
      );
    }
  } else {
    setAlertTwoButtonModal({
      status: true,
      title: "No Item Found",
      msg: "Item Not Found .",
      button1: "Ok",
      button1Click: () => {
        dispatch(setSpinnerLoading(false));
      },
    });
  }
}
